// extracted by mini-css-extract-plugin
export default {"alertBackground":"SoundAlert_alertBackground__9T9nf","alertContainer":"SoundAlert_alertContainer__a4mQe","btn":"SoundAlert_btn__L5L3s"};